/** Shared disabled / aria-busy model for every add-to-cart control. */
export type AtcControlState = {
    disabled: boolean;
    'aria-busy': boolean;
};

export const getAtcControlState = (atcBusy: boolean, epOverflowing: boolean): AtcControlState => ({
    disabled: atcBusy || epOverflowing,
    'aria-busy': atcBusy,
});
